import CategoryFixed from "./CategoryFixed";
import CategoryFixedMobile from "./CategoryFixedMobile";

const CategoryCardTop = ({categories, onCategoryClick,activeCategory }) => {
    return (
        <>
            <CategoryFixed
                categories={categories}
                onCategoryClick={onCategoryClick}
                activeCategory={activeCategory}
            />
            <CategoryFixedMobile
                categories={categories}
                onCategoryClick={onCategoryClick}
                activeCategory={activeCategory}
            />
        </>
    );
};

export default CategoryCardTop;
